<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M8.5 2a1 1 0 00-1 1v6H5a1 1 0 00-1 1v6H3a1 1 0 00-1 1v4a1 1 0 001 1h2a1 1 0 001-1h4a1 1 0 001 1h2a1 1 0 001-1h4a1 1 0 001 1h2a1 1 0 001-1v-4a1 1 0 00-1-1h-1v-6a1 1 0 00-1-1h-2.5V3a1 1 0 00-1-1h-7zm2.5 9v5H6v-5h1v2h3v-2h1zm2 0v5h5v-5h-1v2h-3v-2h-1zm2 0v1h1v-1h-1zm-7 1v-1h1v1H8zm6.5-3V4h-1v2h-3V4h-1v5h5zm-3-5h1v1h-1V4zM4 18v1h16v-1H4z"/></svg>